import React, { useEffect, useState, useRef, useContext } from "react"
import Modal, {
  ModalContent,
  ModalHeader,
  ModalBtnGroup,
} from "../../../components/Modal"
import AppContext from "../../../shared/AppContext"

const SuggestTopicModal = (props) => {
  const {
    isOpen,
    onClose,
    onSubmit,
    submitDisabled,
    didSubmit,
    onReset,
    error,
  } = props

  const { trackEvent } = useContext(AppContext)
  const [topic, setTopic] = useState("")
  const topicInputRef = useRef()
  const topicInputLimit = 250

  useEffect(() => {
    if (!isOpen) {
      handleReset()
    }
  }, [isOpen])

  useEffect(() => {
    if (!didSubmit && isOpen) {
      topicInputRef.current.focus()
    }
  }, [didSubmit, isOpen])

  const validate = () => {
    if (!topic) {
      return false
    }

    return !!topic.trim() && topic.length > 1
  }

  const handleReset = () => {
    onReset()
    setTopic("")
  }

  const handleInputChange = (e) => {
    setTopic(e.target.value)
  }

  const handleSubmit = () => {
    const isValid = validate()
    if (!isValid) {
      return
    }

    onSubmit(topic.trim())
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit()
    }
  }

  const getErrorText = () => {
    if (error === "unknown") {
      return "There was a problem submitting the topic suggestion."
    }

    if (error === "topic_length_too_long") {
      return `Topic must be ${topicInputLimit} characters or less.`
    }

    return "Unable to submit topic suggestion, not authorized."
  }

  return (
    <Modal isOpen={isOpen} classes={["medium"]} onClose={onClose}>
      <ModalContent>
        <ModalHeader text={"Suggest Topic"} />
        {didSubmit ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <i
              className="fas fa-check"
              style={{ color: "#38a169", marginBottom: "1rem" }}
            ></i>
            <p>Successfully submitted topic!</p>
            <a
              style={{
                userSelect: "none",
              }}
              onClick={() => {
                handleReset()
                trackEvent("Insights: Topic Suggestion", {
                  action: "Suggest another topic link click",
                })
              }}
            >
              Submit Another Topic
            </a>
          </div>
        ) : (
          <div>
            <label>Topic Name</label>
            <input
              value={topic}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              placeholder="Enter a topic"
              type="text"
              className={`form-control`}
              ref={topicInputRef}
              maxLength={topicInputLimit}
              data-cy="suggest-topic-input"
            />
            {error ? (
              <p style={{ marginTop: "1rem", color: "red" }}>
                {getErrorText()}
              </p>
            ) : null}
          </div>
        )}
        <ModalBtnGroup
          style={{ justifyContent: didSubmit ? "center" : "right" }}
        >
          <button
            onClick={onClose}
            className="btn btn-secondary"
            data-cy="modal-cancel"
          >
            Close
          </button>
          {!didSubmit && (
            <button
              disabled={!validate() || submitDisabled}
              onClick={handleSubmit}
              className="btn btn-primary"
              data-cy="modal-confirm"
            >
              Submit
            </button>
          )}
        </ModalBtnGroup>
      </ModalContent>
    </Modal>
  )
}

export default SuggestTopicModal
